<template>
  <div>
    <div class="jumbotron">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item"><a href="#/apps">Apps</a></li>
        <li class="breadcrumb-item active">View</li>
      </ol>
    </div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#query-visualizer">Query Visualizer</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#query-stats">Query Stats</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#sf-stats" ref="sfStatsRef">Scheduled Function Stats</a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade active show" id="query-visualizer">
        <div class="row">
          <div class="col-6">
            <form>
              <fieldset>
                <div class="form-group">
                  <div class="input-group">
                    <label class="col-4 col-form-label">
                      <i class="fa fa-pie-chart" aria-hidden="true"></i> Chart Metric
                    </label>
                    <select class="form-control" v-model="chartType">
                      <option disabled value="">Please select a chart metric</option>
                      <option v-for="entry in chartTypeDropdown">
                          {{ entry.label }}
                      </option>
                    </select>
                  </div>
                  <div class="input-group">
                    <label class="col-4 col-form-label">
                      <i class="fa fa-sort" aria-hidden="true"></i> Sort
                    </label>
                    <select class="form-control" v-model="chartSortType">
                      <option disabled value="">Please select a sort type</option>
                      <option>
                        Ascending
                      </option>
                      <option>
                        Descending
                      </option>
                    </select>
                  </div>
                  <div class="input-group">
                    <label class="col-4 col-form-label">
                      <i class="fa fa-sort-numeric-asc" aria-hidden="true"></i> Number of results
                    </label>
                    <select class="form-control" v-model="chartResultSetSize">
                      <option disabled value="">Please select a number of results</option>
                      <option v-for="i in chartResultSetSizes">
                        {{ i }}
                      </option>
                    </select>
                  </div>
                </div>
              </fieldset>
            </form>
            <div v-if="chartData">
              <pie-chart
                :chartData="chartData"
                :options="{responsive: true, maintainAspectRatio: true}">
              </pie-chart>
            </div>
          </div>
          <div class="col-6">
            <div v-if="chartData" v-for="entry in chartQueries">
              <pre v-highlightjs="entry"><code class="sql"></code></pre>
            </div>
          </div>
         </div>
      </div>
        <div class="tab-pane fade" id="query-stats">
          <div class="row">
            <div class="col">
              <div v-if="statsLoading">
                <strong>Results are loading ...</strong> This is a heavy query and can take some time to process please be patient.
              </div>
              <div v-else>
                <div v-if="rows.length > 0">
                  <vue-good-table
                      :columns="columns"
                      :rows="rows"
                      @on-row-click="onClickFn"
                      :sort-options="{
                        enabled: true,
                        initialSortBy: {field: 'mean_time', type: 'desc'}
                      }"
                      :search-options="{ enabled: true }"
                      :paginationOptions="{ enabled: true }"
                      styleClass="vgt-table striped bordered table-hover"
                      :lineNumbers="true">
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'query'">{{ props.row.query }}</span>
                      <span v-if="props.column.field == 'calls'">{{ props.row.calls }}</span>
                      <span v-if="props.column.field == 'total_time'">{{ props.row.total_time }}</span>
                      <span v-if="props.column.field == 'min_time'">{{ props.row.min_time }}</span>
                      <span v-if="props.column.field == 'max_time'">{{ props.row.max_time }}</span>
                      <span v-if="props.column.field == 'mean_time'">{{ props.row.mean_time }}</span>
                      <span v-if="props.column.field == 'stddev_time'">{{ props.row.stddev_time }}</span>
                      <span v-if="props.column.field == 'rows'">{{ props.row.rows }}</span>
                    </template>
                  </vue-good-table>
                </div>
                <div v-else>
                  <strong>No Results found!</strong> No recently PG stats could be found.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="sf-stats">
          <div class="row">
            <div class="col">
                <loading :active.sync="sfLoading"></loading>
                <div v-if="sfLoading">
                  <strong>Results are loading ...</strong> This is a heavy query and can take some time to process please be patient.
                </div>
                <div v-else>
                  <div v-if="functionResults.length > 0">
                    <vue-good-table
                        title="Processed Scheduled Functions"
                        :columns="functionColumns"
                        :rows="functionResults"
                        :sort-options="{
                          enabled: true,
                          initialSortBy: {field: 'started', type: 'desc'}
                        }"
                        :search-options="{ enabled: true }"
                        :paginationOptions="{ enabled: true }"
                        styleClass="vgt-table striped bordered table-hover">
                    </vue-good-table>
                  </div>
                  <div v-else>
                    <strong>No Results found!</strong> No recently processed scheduled function stats cound be found.
                  </div>
                </div>
            </div>
          </div>
        </div>
    </div>

    <modal
      :show.sync="modalShowDetail"
      :backdrop="modalBackdrop"
      effect="zoom"
      large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <i class="fa fa-info" aria-hidden="true"></i> Query Pattern Detail
        </h4>
      </div>
      <div slot="modal-body" class="modal-body" v-if="selectedQuery">
        <pre v-highlightjs="selectedQuery.query"><code class="sql"></code></pre>
        <form>
          <fieldset>
            <div class="form-group">
              <div class="input-group">
                <label class="col-6 col-form-label">Number of Calls</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.calls" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Total Time spend processing</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.total_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Minimum Time query has lasted</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.min_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Maximum Time query has lasted</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.max_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Mean Time spend processing query</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.mean_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Standard deviation of time processing query</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.stddev_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Total Rows retrieved or affected by query</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.rows" readonly="true" />
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click="closeModalShowDetail">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
  import PieChart from '@/components/PieChart.vue'
  import { modal } from 'vue-strap'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.min.css'
  export default {
    components: {
      modal,
      PieChart,
      Loading
    },
    data: function () {
      return {
        app: null,
        columns: [
          {
            label: 'Query',
            field: 'query',
            filterable: true
          },
          {
            label: 'Calls',
            field: 'calls',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Total Time',
            field: 'total_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Min Time',
            field: 'min_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Max Time',
            field: 'max_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Mean Time',
            field: 'mean_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Standard Deviation',
            field: 'stddev_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Rows retrieved or affected',
            field: 'rows',
            filterable: true,
            type: 'number'
          }
        ],
        rows: [],
        chartQueries: [],
        chartData: null,
        chartResultSetSize: 5,
        chartSortType: 'Descending',
        chartType: 'Mean Time',
        modalShowDetail: false,
        modalBackdrop: false,
        selectedQuery: null,
        loading: true,
        functionResults: [],
        functionColumns: [
          {
            label: 'Function Name',
            field: 'qualifiedName'
          },
          {
            label: 'Started',
            field: 'started'
          },
          {
            label: 'Finished',
            field: 'finished'
          },
          {
            label: 'Exception',
            field: 'exception'
          },
          {
            label: 'Stacktrace',
            field: 'stacktrace'
          }
        ],
        statsLoading: false,
        sfLoading: false
      }
    },
    methods: {
      getPgStats: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/db-spy/stats'
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['appId'] = vm.app.id
        vm.statsLoading = true
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.$parent.loading = false
            vm.rows = response.data
            vm.statsLoading = false
            if (vm.rows.length <= 0) {
              let obj = {
                title: 'No stats found!',
                message: 'No postgres statement stats found on ' + endpoint,
                type: 'error'
              }
              vm.$Simplert.open(obj)
            }
            vm.maybeUpdateChartData()
          })
          .catch(function (error) {
            vm.$parent.loading = false
            vm.statsLoading = false
            let obj = {
              title: 'Error getting stats!',
              message: error.response.data,
              type: 'error'
            }
            vm.$Simplert.open(obj)
            console.log(error)
          })
      },
      maybeUpdateChartData: function () {
        let vm = this
        if (vm.chartType !== null && vm.chartSortType !== null && vm.chartResultSetSize != null) {
          vm.setChartData()
        }
      },
      setChartData: function () {
        let vm = this

        vm.chartQueries = []

        let chartLabels = []
        let chartDataElements = []
        let chartColours = []
        let chartDatasets = []

        let chartTypeField = vm.formatChartTypeLabelToField(vm.chartType)

        // Sort desc by chart type
        let rowsData = this.rows.slice().sort(
          function (a, b) {
            if (vm.chartSortType === 'Ascending') {
              return a[chartTypeField] - b[chartTypeField]
            } else if (vm.chartSortType === 'Descending') {
              return b[chartTypeField] - a[chartTypeField]
            }
          }
        )
        for (var i = 0; i < vm.chartResultSetSize && i < rowsData.length; i++) {
          var ele = rowsData[i]
          chartLabels.push('#' + (i + 1) + ' ' + chartTypeField)
          let suffix = chartTypeField === 'total_time' || chartTypeField === 'min_time' || chartTypeField === 'max_time' || chartTypeField === 'mean_time' || chartTypeField === 'stddev_time' ? 's' : ''
          vm.chartQueries.push('-- Query #' + (i + 1) + '\n' + ele.query + '\n-- Value:\n' + ele[chartTypeField] + suffix + ' ' + vm.chartType)
          chartDataElements.push(ele[chartTypeField])
          chartColours.push(vm.getRandomColor())
        }
        chartDatasets.push({
          backgroundColor: chartColours,
          data: chartDataElements
        })
        vm.chartData = {
          labels: chartLabels,
          datasets: [
            {
              backgroundColor: chartColours,
              data: chartDataElements
            }
          ]
        }
      },
      formatChartTypeLabelToField: function (value) {
        let vm = this
        if (vm.chartType === null) {
          return null
        }
        let result = null
        vm.columns.slice().filter(function (item) {
          return item.label === value
        }).forEach(function (element) {
          result = element.field
        })
        return result
      },
      getRandomColor: function () {
        var letters = '0123456789ABCDEF'
        var color = '#'
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }
        return color
      },
      onClickFn: function (row, index) {
        let vm = this
        vm.selectedQuery = row
        vm.modalShowDetail = true
      },
      closeModalShowDetail: function () {
        let vm = this
        vm.modalShowDetail = false
      },
      getScheduledFunctions: function () {
        let vm = this
        vm.sfLoading = true
        vm.functionResults = []

        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['uuid'] = vm.app.id

        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/debug/scheduled-function'

        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.functionResults = response.data
            vm.sfLoading = false
          })
          .catch(function (error) {
            vm.sfLoading = false
            let obj = {
              title: 'Error getting scheduled-function stats!',
              message: error.response.data,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      }
    },
    computed: {
      chartTypeDropdown: function () {
        let vm = this
        return vm.columns.slice().filter(function (item) {
          return item.field !== 'query'
        })
      },
      chartResultSetSizes: function () {
        let values = []
        for (var i = 5; i <= this.rows.length; i = i + 5) {
          values.push(i)
        }
        return values
      }
    },
    created () {
      let vm = this
      vm.$parent.apps.forEach(function (key) {
        if (key.id === vm.$route.params.appid) {
          vm.app = key
        }
      })
      if (vm.app == null) {
        vm.$router.push({name: 'Apps'})
        return
      }
      vm.getPgStats()
      vm.getScheduledFunctions()
      window.addEventListener('keydown', function (e) {
        if (e.keyCode === 27) {
          vm.closeModalShowDetail()
        }
      })
    },
    watch: {
      'chartType': function (newValue) {
        let vm = this
        vm.maybeUpdateChartData()
      },
      'chartSortType': function (newValue) {
        let vm = this
        vm.maybeUpdateChartData()
      },
      'chartResultSetSize': function (newValue) {
        let vm = this
        vm.maybeUpdateChartData()
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// AppView.vue?2b65010a